// extracted by mini-css-extract-plugin
module.exports = {"articleLink":"ArticleLink-module--article-link--2LQSG","pressImage":"ArticleLink-module--pressImage--We8VA"};